// @ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import { JSDCContext, JSDCProvider } from "jsdc-dui/dist/JSDC/Context";
import JSDC from "jsdc-dui/dist/JSDC";
import { latLng, latLngBounds } from "leaflet";
import {
  IDuiContextProviderProps,
  DuiContextProvider,
  DuiContext,
} from "jsdc-dui/dist/components/Context";
import DguideWalksApp from "jsdc-dui/dist/components/DguideWalksApp";
import { DguidewalksProvider } from "jsdc-dui/dist/JSDC/Dguidewalks/Context";
import "jsdc-dui/dist/style/index.css";
import "./index.scss";
import ConfigProvider from "jsdc-dui/dist/JSDC/Dguidewalks/ConfigProvider";
import MenuItemWithDialog from "jsdc-dui/dist/components/LeftMenuBar/MenuList/MenuItemWithDialog";
import Checkin from "jsdc-dui/dist/components/Icons/Checkin";
import headerImg from "./assets/header.png";
import headerImgMb from "./assets/header-mb.jpg";
import kanbanImg from "./assets/kanban.png";
import aboutImg from "./assets/about.png";
// import M0001ArticleParser from "./M0001ArticleParser"
import creditLogo1 from "./assets/2306_logo01.png";
import creditLogo2 from "./assets/2306_logo02.png";
import creditLogo3 from "./assets/2306_logo03.png";

const EVENT_ID = "m0001";

const aboutWalkContent = `這是一條以彰化基督教醫院「國際文史園區」景點組成的數位走讀路線，藉由對彰化基督教醫院在地文史故事的串接走讀，感受彰化基督教醫院在中臺灣地區所帶來的醫療故事，以及西方醫學在此地的發展過程。彰化基督教醫院由蘭大衛（David Landsborough, 1870-1957）設立，是中臺灣歷史最悠久的醫學中心。蘭大衛醫師1870年生於蘇格蘭，1895年愛丁堡大學醫學院畢業，成為醫療宣教師。因當時在臺灣從事醫療宣教的盧加閔醫師（Gavin Russell, 1866-1892）不幸身染傷寒病逝，造成臺灣宣教醫療上的人力短缺。對於蘭大衛醫生影響深遠的修．巴伯博士（Hugh Barbour）推薦他到福爾摩沙任職，蘭大衛同意後便被英國長老教會派往臺灣中部，於1895年10月16日啟航。蘭大衛醫生初來臺時，首先在府城學習臺語，並於1896年前往中部的彰化教會，以補上盧嘉敏醫師的職位空缺，並與梅鑑霧牧師（Campbell Naismith Moody, 1865-1940）互相合作，由蘭大衛醫師進行醫療宣教，而梅鑑霧牧師則到各處進行臺語福音宣教、佈道。
蘭大衛醫師是彰化基督教醫院的首任院長，而其子蘭大弼醫師（David Landsborough Ⅳ, 1914-2010）則為第九任院長。兩代蘭醫師都是中臺灣宣教醫療的創啟者中貢獻良多的醫者，他們所流下的點滴故事更為臺灣醫療史留下美好的一頁。本走讀路線的建置由教育部111學年度教學實踐研究計畫「漫步在彰基—彰化基督教醫院史蹟故事走讀平臺建置計畫」與彰化縣文化局「112-113年度博物館及地方文化館升級計畫：彰基文史博物館數位走讀提升計畫」支持，由彰化師範大學歷史學研究所、彰基文史博物館，以及智紳數位文化事業有限公司籌劃，在彰化師範大學胡其瑞助理教授於校內開設的「地方文史創意導覽」課程中與修習同學們共同建置完成。透過修習同學的田野調查、博物館參訪，以及動手實作，運用現代科技的數位走讀方法，建構彰化基督教醫院過去逾百年的風華歷史。
`;

const credit = `
<div>
    <p>
    本走讀路線的建置由教育部111學年度教學實踐研究計畫「漫步在彰基—彰化基督教醫院史蹟故事走讀平臺建置計畫」與彰化縣文化局「112-113年度博物館及地方文化館升級計畫：彰基文史博物館數位走讀提升計畫」支持，由彰化師範大學歷史學研究所、彰化基督教文史博物館，以及智紳數位事業有限公司籌劃，在彰化師範大學胡其瑞助理教授於校內開設的「地方文史創意導覽」課程中與修習同學王建凱、江惠廷、李宜昀、范博翔、夏千芊、袁嘉良、張力元、陳法融、陳靜雯、黃郁淇、鄭惠文（依姓名筆畫排序）共同建置完成。透過修習同學的田野調查、博物館參訪，以及動手實作，運用現代科技的數位走讀方法，建構彰化基督教醫院過去逾百年的風華歷史。
    </p>
</div>
`;

const duiConfigProps: IDuiContextProviderProps = {
  sidebarTitle: "",
  sidebarSubtitle: "",
  aboutWalkImgSrc: aboutImg,
  aboutWalkContent,
  credit,
  creditHref: "https://www.facebook.com/JRSHENDigitalCulture/",
  headerMBImgSrc: headerImgMb,
  headerDImgSrc: headerImg,
  menuSwitchItems: [{ id: "數位集章", name: "數位集章" }],
  weatherConfig: {
    token: "CWB-232A270E-12F1-4381-B9F2-DF2D2670A077",
    locations: [{ county: "彰化縣", town: "彰化市" }],
  },
  themeConfig: {
    "--dui-primary": "#02DF82",
    "--dui-accent": "#EAA625",
    "--dui-secondary": "#02DF82",
    "--dui-bg-secondary": "#EB9D1D",
    "--dui-bg-accent": "#00CACA",
  },
  settingConfig: {
    disabled: true, // 左側選單不出現「工具設定」
    // languageSwitcherDisabled: true, // 或：保留「工具設定」，只藏語言切換器
  },
};

// 景點的 icon、點擊開集章卡片、集章 key、`?id=` 深連結、
// 列表的定位與導航、底圖、線都由 jsdc-dui 依 Strapi 的資料建立，這裡不需要再處理圖層。
function App() {
  const { Jsdc } = useContext(JSDCContext);
  const dui = useContext(DuiContext);

  useEffect(() => {
    (window as any).JSDC = Jsdc;
    // 把logo硬加上去
    const creditElem = document.getElementsByClassName(
      "dui-CreditDialogContent",
    )[0];
    creditElem.querySelector("img.qr-code")?.remove();
    const finalBlock = creditElem.querySelector(".final");
    finalBlock?.querySelector("a")?.remove();
    const createLogoImg = (src: string) => {
      const img = new Image();
      img.src = src;
      img.style.height = "57px";
      return img;
    };
    finalBlock?.appendChild(createLogoImg(creditLogo1));
    finalBlock?.appendChild(createLogoImg(creditLogo2));
    finalBlock?.appendChild(createLogoImg(creditLogo3));

    // 嵌入YouTube影片
    const aboutWalkContentElem = document.querySelector(
      ".dui-AboutWalkDialogContent-content",
    );
    const iframe = document.createElement("iframe");
    iframe.src = "https://www.youtube.com/embed/AMxpkwmlges";
    iframe.title = "YouTube video player";
    iframe.frameBorder = "0";
    iframe.allow =
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
    iframe.allowFullscreen = true;
    aboutWalkContentElem?.appendChild(iframe);

    // 添加影片製作文字
    const creditText = document.createElement("p");
    creditText.innerText =
      "影片製作：國立彰化師範大學國文系／江惠廷、袁嘉良、鄭惠文";
    creditText.style.fontSize = "0.8rem";
    aboutWalkContentElem.appendChild(creditText);
  }, [Jsdc]);

  return (
    <div className="root">
      <DguideWalksApp
        language="zh-TW"
        mainMenuChildren={
          <MenuItemWithDialog
            Icon={Checkin}
            title="數位集章"
            active={dui.activeMenuId === "數位集章"}
            {...dui.menuSwitcherAction("數位集章")}
          >
            {dui.activeMenuId === "數位集章" && (
              <iframe
                title="數位集章"
                style={{ height: "100%", border: 0, borderRadius: "5px" }}
                src={`https://map.jsdc.com.tw/tools/checkin/${EVENT_ID}/showlist.php?a=${EVENT_ID}`}
              ></iframe>
            )}
          </MenuItemWithDialog>
        }
      />
    </div>
  );
}

const config = new ConfigProvider({ eventId: EVENT_ID });

const AppWrapper: React.FC = () => {
  const [Jsdc] = useState(
    new JSDC(EVENT_ID, {
      bound: latLngBounds(
        latLng(24.066155941363952, 120.5336880683899),
        latLng(24.082259939483926, 120.55025339126588),
      ),
      maxZoom: 19,
    }),
  );

  return (
    <JSDCProvider Jsdc={Jsdc}>
      <DguidewalksProvider Jsdc={Jsdc} config={config}>
        <DuiContextProvider
          {...duiConfigProps}
          sceneConfig={{ cluster: false, checkinKanbanImgSrc: kanbanImg }}
        >
          <App />
        </DuiContextProvider>
      </DguidewalksProvider>
    </JSDCProvider>
  );
};

export default AppWrapper;
